import { DataRoomTeaserPreview } from '../../shared/models';
import { CerebroDrawer, CerebroHeading } from '../../shared/components';
import { sanitize } from 'dompurify';

interface InvitePreviewProps {
	open: boolean;
	preview: DataRoomTeaserPreview;
	onClose: () => void;
}

export const InvitePreview: React.FC<InvitePreviewProps> = ({ open, preview, onClose }) => {
	return (
		<CerebroDrawer open={open} onClose={onClose} PaperProps={{ sx: { width: '850px' } }}>
			<CerebroHeading size="h2" sx={{ marginBottom: 3 }}>
				{preview.subject}
			</CerebroHeading>

			<div id="emailPreview" dangerouslySetInnerHTML={{ __html: sanitize(preview.html) }}></div>
		</CerebroDrawer>
	);
};
